import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem } from '@material-ui/core';
import CalendarIcon from '@material-ui/icons/CalendarTodayOutlined';
import { PickerField } from 'lib';
import { useTimeSettingsFormat } from 'common/useTimeSettingsFormat';
import { shortDate } from 'helpers/_date-helpers';

const DAYS = ['-1', '0', '1'];

const DayInput = ({ value, onChange, baseDate, disabled, error, className }) => {
  const anchor = useRef(null);
  const [open, setOpen] = useState(false);
  const { localDayMonth } = useTimeSettingsFormat()();

  const label = (day) => shortDate(baseDate, day, localDayMonth);

  return (
    <>
      <PickerField
        ref={anchor}
        icon={<CalendarIcon />}
        open={open}
        error={error}
        disabled={disabled}
        className={className}
        onClick={() => setOpen(true)}
      >
        {value && label(value)}
      </PickerField>
      <Menu
        open={open}
        anchorEl={anchor.current}
        onClose={() => setOpen(false)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        PaperProps={{ style: { minWidth: anchor.current?.offsetWidth } }}
      >
        {DAYS.map((day) => (
          <MenuItem
            key={day}
            selected={day === value}
            onClick={() => {
              onChange(day);
              setOpen(false);
            }}
          >
            {label(day)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

DayInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  baseDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  className: PropTypes.string,
};

DayInput.defaultProps = {
  value: '',
  disabled: false,
  error: false,
  className: undefined,
};

export default DayInput;
